// groupChildNodesByType.js

import { expandRelatedTypeOrder } from 'utilities/nodeTypeRelatedLists';

export const getDisplayType = (node) => {
  if (!node) return '';
  return node.type || '';
};

/**
 * Groups child nodes by display type and returns an ordering based on typeOrder.
 *
 * @param {object} params
 * @param {object[]} params.childNodes
 * @param {Array} params.typeOrder - Preferred type order (suggestedChildren; may include alsoShowTabs).
 * @param {boolean} params.showOnlyProfileRoot
 *
 * @returns {{ map: Map<string, object[]>, orderedKeys: string[] }}
 */
export const groupChildNodesByType = ({
  childNodes = [],
  typeOrder = [],
  showOnlyProfileRoot = false,
} = {}) => {
  const map = new Map();
  const resolvedTypeOrder = expandRelatedTypeOrder(typeOrder);

  for (const node of childNodes) {
    const displayType = getDisplayType(node);
    if (!displayType) continue;

    if (showOnlyProfileRoot && !node.profileRoot) continue;

    if (!map.has(displayType)) map.set(displayType, []);
    map.get(displayType).push(node);
  }

  const orderedKeys = Array.from(map.keys()).sort((a, b) => {
    const aIdx = resolvedTypeOrder.indexOf(a);
    const bIdx = resolvedTypeOrder.indexOf(b);
    const aPriority = aIdx === -1 ? Infinity : aIdx;
    const bPriority = bIdx === -1 ? Infinity : bIdx;

    if (aPriority === bPriority) return a.localeCompare(b);
    return aPriority - bPriority;
  });

  return { map, orderedKeys };
};
